import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
} from "reactstrap";
import BaseTable from "components/shared/BaseTable";
import { BASE_URL, API } from "CONST";
import { headerOperation, cellOperation, cellDateOperation } from "helpers/tables";
import { fileDownload } from "helpers/helpers";
import SafeBtn from '../../../shared/SafeBtn';

const CreditLineDetailComentariosModal = ({ openModal, closeModal, comentarios, movimientoIdComentarios }) => {
  const loginIdToken = useSelector((state) => state.login.id_token);

  const columns = [
    {
        Header: headerOperation('Fecha', 'center'),
        id: "fecha",
        accessor: "fecha_creacion",
        Cell: (row) => cellDateOperation(row.value, 'HH:mm - DD/MM/YYYY'),
        minWidth: 150,
    },
    {
        Header: headerOperation('Analista', 'center'),
        id: "analista",
        accessor: "nombre_author",
        Cell: (row) => cellOperation(row.value),
        minWidth: 200,
    },
    {
        Header: headerOperation('Comentario', 'center'),
        id: "comentario",
        accessor: "comentario",
        Cell: (row) => cellOperation(row.value),
        minWidth: 500,
    },
    {
        Header: headerOperation('Documentos', 'center'),
        id: "documentos",
        accessor: "documentos_data",
        Cell: (row) => cellOperation(
          <Col>
            {row.value.map(r => (
              <Row key={r.id} style={{ justifyContent: 'center' }}>
                <SafeBtn
                  className="table-link download"
                  onClick={() => fileDownload(`${BASE_URL}${API.downloadDocumento}/${r.id}`, loginIdToken)}
                >
                  {r.original_name}
                </SafeBtn>
              </Row>
            ))}
          </Col>
        ),
        minWidth: 250,
    },
    {
        Header: headerOperation('Notificacion', 'center'),
        id: "notificacion",
        accessor: "notification_pool_data",
        Cell: (row) => cellOperation(
          <Col>
            {row.value.map(r => (
              <Row key={r.id} style={{ justifyContent: 'center' }}>
                {`${r.first_name} ${r.last_name}`}
              </Row>
            ))}
          </Col>
        ),
        minWidth: 200,
    },
  ]
  return (
    <Modal
      isOpen={openModal}
      style={{maxWidth: "1500px"}}
      toggle={closeModal}
      type="modal-warning warning-container"
    >
      <ModalHeader toggle={closeModal}>
        {`Comentarios para Movimiento de Línea ID ${movimientoIdComentarios}`}
      </ModalHeader>
      <ModalBody>
        <div style={{ marginBottom: "15px" }}>
          <BaseTable
            columns={columns}
            data={comentarios}
            sortable={false}
            style={{ maxHeight: '63vh' }}
          />
        </div>
      </ModalBody>
    </Modal>
  );
}

CreditLineDetailComentariosModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  comentarios: PropTypes.arrayOf(
    PropTypes.object,
  ).isRequired,
  movimientoIdComentarios: PropTypes.number,
};

CreditLineDetailComentariosModal.defaultProps = {
  movimientoIdComentarios: null
};

export default CreditLineDetailComentariosModal;
